import { Navigate, useLocation, useRoutes } from 'react-router';
import HomePage from './pages/HomePage/HomePage';
import UserDashboardPage from './pages/UserDashboardPage/UserDashboardPage';
import UserProfilePage from './pages/UserProfilePage/UserProfilePage';
import PartnerGamesPage from './pages/PartnerGamesPage/PartnerGamesPage';
import PartnerDashboardPage from './pages/PartnerDashboardPage/PartnerDashboardPage';
import PartnerProfilePage from './pages/PartnerProfilePage/PartnerProfilePage';
import UserPassPage from './pages/UserPassPage/UserPassPage';
import UserOrderPage from './pages/UserOrderPage/UserOrderPage';
import PolicyPage from './pages/PolicyPage/PolicyPage';
import ContactPage from './components/ContactPage/ContactPage';
import PaymentsPage from './components/PaymentsPage/PaymentsPage';
import PartnerApiPage from './components/PartnerApiPage/PartnerApiPage';
import Layout from './components/Layout/Layout';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';

function App() {
  const { pathname } = useLocation();

  const isCabinet = () => {
    switch (pathname) {
      case '/cabinet/user/dashboard':
        return true;
      case '/cabinet/user/profile':
        return true;
      case '/cabinet/partner/dashboard':
        return true;
      case '/cabinet/partner/profile':
        return true;
      case '/cabinet/partner/api':
        return true;
      case '/cabinet/partner/games':
        return true;
      case '/cabinet/user/pass':
        return true;
      case '/privacy-policy':
        return true;
      case '/payments':
        return true;
      case '/contacts':
        return true;
      default:
        return false;
    }
  };
  console.log(isCabinet);
  // const isLayout = pathname == '/' || pathname.includes('/order');
  let routes = useRoutes([
    {
      path: '*',
      element: <NotFoundPage />,
    },
    {
      path: '/',
      element: <HomePage />,
    },
    {
      path: '/cabinet/user/dashboard',
      element: <UserDashboardPage />,
    },
    {
      path: '/cabinet/user/profile',
      element: <UserProfilePage />,
    },
    {
      path: '/cabinet/partner/dashboard',
      element: <PartnerDashboardPage />,
    },
    {
      path: '/cabinet/partner/profile',
      element: <PartnerProfilePage />,
    },
    {
      path: '/cabinet/partner/api',
      element: <PartnerApiPage />,
    },
    {
      path: '/cabinet/partner/games',
      element: <PartnerGamesPage />,
    },
    {
      path: '/cabinet/user/pass',
      element: <UserPassPage />,
    },
    {
      path: '/order/:transactionId',
      element: <UserOrderPage />,
    },
    {
      path: '/privacy-policy',
      element: <PolicyPage />,
    },
    {
      path: '/payments',
      element: <PaymentsPage />,
    },
    {
      path: '/contacts',
      element: <ContactPage />,
    },
    // {
    //   path: '/admin/banner/update/:slug',
    //   element: (
    //     <AdminLayout>
    //       <AdminBannerUpdate />
    //     </AdminLayout>
    //   ),
    // },
  ]);

  return isCabinet() ? <Layout>{routes}</Layout> : routes;
}

export default App;
